import React from 'react';
import { Link } from 'react-router-dom';
import { orderDetailsPath } from '@/constants/routes';
import { useLinkedOrderNavigation } from './hooks';

/**
 * A link from one order's details page to a linked order (parent, split child, clone). It carries the hop count, so
 * "My Orders" on the next page still returns to the list instead of to this order.
 *
 * @param {{ orderId: string }} props Any other props go to the router `Link`.
 */
const LinkedOrderLink = ({ orderId, ...rest }) => {
    const { linkState } = useLinkedOrderNavigation();
    return <Link to={orderDetailsPath(orderId)} state={linkState} {...rest} />;
};

export default LinkedOrderLink;
